export default __webpack_public_path__ + "assets/models/a5a69b0bd53f34660ccf8615ef9b9ab7.glb";